var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"video-wrapper"},[_c('video',{attrs:{"id":"myVideo","controls":"controls","autoplay":"autoplay"}})])])
}]

export { render, staticRenderFns }